import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { takeUntil, Subject } from 'rxjs';

import { filterBoolean } from '@recruitee/common';
import { RequisitionAssignmentsSelectors } from '@recruitee/requisitions-data';
import type { RequisitionAssignment } from '@recruitee/requisitions-types';

import { RequisitionsTeamContainerComponent } from '../../../containers/single-requisition/requisitions-team-container/requisitions-team-container.component';

@Component({
  selector: 'rt-requisitions-team-page',
  templateUrl: './team-page.component.html',
  styleUrls: ['./team-page.component.less'],
  standalone: true,
  imports: [RequisitionsTeamContainerComponent],
})
export class TeamPageComponent {
  public requisitionId: number;
  public assignments: RequisitionAssignment[];

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    const id = Number(this.route.parent?.snapshot.params.id);

    this.requisitionId = id;
    this.cdRef.detectChanges();

    this.store
      .select(RequisitionAssignmentsSelectors.byId(id))
      .pipe(filterBoolean, takeUntil(this.ngOnDestroy$))
      .subscribe(data => {
        this.assignments = data.assignments;
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
